import {ApiClientProvider} from "../../../../core/data-access/http-client/clients/api-client-provider.service";
import { ISystemRolesApiClient} from "./i-system-roles-api.client";
import { SystemRolesApiClient} from "./system-roles.api.client";
import { SystemRolesApiInMemoryClient} from "./system-roles.api.inmemory.client";
import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class SystemRolesApiClientProvider extends ApiClientProvider<ISystemRolesApiClient> {

    constructor(private client: SystemRolesApiClient, private inMemoryClient: SystemRolesApiInMemoryClient) {
      super();
    }

    protected override getInMemoryClient(): ISystemRolesApiClient {
        return this.inMemoryClient;
    }
    protected override getApiClient(): ISystemRolesApiClient {
        return this.client;
    }
}
